<div class="header__row">
    <div class="header__nav-group header__nav-group--primary-menu">
        <website-header-v2-logo></website-header-v2-logo>

        <nav class="header-menu">
            <ul class="header-menu__list header-list">
                @for (navigationItem of primaryNavigation; track navigationItem.key) {
                    @if (hasUrl(navigationItem)) {
                        <li class="header-menu__item header-list__item">
                            <a
                                data-application="header-menu-link"
                                class="header-menu__link header-list__link header-menu__link--{{ navigationItem.key }}"
                                [href]="getUrl(navigationItem)"
                                >{{ navigationItem.title }}</a
                            >
                        </li>
                    } @else {
                        @if (headerService.checkIsNavigationItemWithSubmenu(navigationItem)) {
                            <li
                                class="header-menu__item header-list__item header-menu__item--has-sub-menu"
                                [ngClass]="{
                                    'header-menu__item--open': openedNavigationItem() === navigationItem.title,
                                }"
                                (click)="onClickSubmenu(navigationItem.title)"
                            >
                                <button
                                    data-application="header-menu-button"
                                    type="button"
                                    class="header-menu__link header-list__link header-menu__link--{{
                                        navigationItem.key
                                    }}"
                                    [id]="SUBMENU_TRIGGER_BASE_ID + navigationItem.key"
                                    [attr.aria-haspopup]="'true'"
                                    [attr.aria-expanded]="'false'"
                                    [attr.aria-controls]="SUBMENU_CONTENT_BASE_ID + navigationItem.key"
                                    [innerHTML]="navigationItem.title | safeHtml"
                                ></button>
                            </li>
                        }
                    }

                    <li class="header-menu__nav header-menu__nav--{{ theme }}">
                        <div
                            data-application="header-sub-menu"
                            class="nav-item"
                            [ngClass]="{ 'nav-item--open': openedNavigationItem() }"
                        >
                            @if (navigationItem.layout_type === 'four-groups' && hasSubgroups(navigationItem)) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-four-groups-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="
                                            navigationItem.layout_type === 'four-groups' &&
                                            openedNavigationItem() === navigationItem.title
                                        "
                                    ></website-four-groups-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (navigationItem.layout_type === 'one-group-and-promo' && hasLinks(navigationItem)) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-one-group-and-promo-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="
                                            navigationItem.layout_type === 'one-group-and-promo' &&
                                            openedNavigationItem() === navigationItem.title
                                        "
                                    ></website-one-group-and-promo-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksGroup]="navigationItem"
                                        [promo]="navigationItem?.promo"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (
                                navigationItem.layout_type === 'two-groups-and-promo' && hasSubgroups(navigationItem)
                            ) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-two-groups-and-promo-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="
                                            navigationItem.layout_type === 'two-groups-and-promo' &&
                                            openedNavigationItem() === navigationItem.title
                                        "
                                    ></website-two-groups-and-promo-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                        [promo]="navigationItem?.promo"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (
                                navigationItem.layout_type === 'two-groups-three-and-one-columns' &&
                                hasSubgroups(navigationItem)
                            ) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-two-groups-three-and-one-columns-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === navigationItem.title"
                                    ></website-two-groups-three-and-one-columns-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (
                                (navigationItem.layout_type === 'tabs-two-groups' ||
                                    navigationItem.layout_type === 'tabs-one-group') &&
                                hasSubgroups(navigationItem)
                            ) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-tabs-groups-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === navigationItem.title"
                                        [tabType]="navigationItem.layout_type"
                                    ></website-tabs-groups-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (
                                navigationItem.layout_type === '2-groups-and-one-group-with-background' &&
                                hasSubgroups(navigationItem)
                            ) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-two-groups-and-bg-group-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === navigationItem.title"
                                    ></website-two-groups-and-bg-group-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (navigationItem.layout_type === '2-columns-and-promo' && hasSubgroups(navigationItem)) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-two-columns-and-promo
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === navigationItem.title"
                                    ></website-two-columns-and-promo>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                        [promo]="navigationItem?.promo"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (navigationItem.layout_type === '3-groups-and-promo' && hasSubgroups(navigationItem)) {
                                @defer (when openedNavigationItem(); prefetch on idle) {
                                    <website-three-groups-and-promo-section
                                        [navigationItem]="navigationItem"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === navigationItem.title"
                                    ></website-three-groups-and-promo-section>
                                } @placeholder {
                                    <website-header-v2-section-placeholder
                                        [linksSubgroups]="navigationItem"
                                        [promo]="navigationItem?.promo"
                                    ></website-header-v2-section-placeholder>
                                } @error {}
                            }
                            @if (filteredCTAList(navigationItem?.cta_list).length) {
                                <div
                                    class="bottom-cta__container"
                                    [class]="
                                        openedNavigationItem() === navigationItem.title
                                            ? 'nav-item--open'
                                            : 'nav-item--close'
                                    "
                                >
                                    <website-call-to-actions
                                        class="bottom-cta__wrapper"
                                        [ngClass]="navigationItem.layout_type"
                                        [callToActions]="filteredCTAList(navigationItem?.cta_list)"
                                        [commonWidgetData]="{ colorScheme: bottomCtaColorScheme }"
                                    ></website-call-to-actions>
                                </div>
                            }
                        </div>
                    </li>
                }
            </ul>
        </nav>
    </div>

    @if (!headerViewService.hideRightSide) {
        <div class="header__nav-group header__nav-group--secondary-menu" data-application="header-secondary-menu">
            @if (secondaryNavigation.contactSales) {
                <div class="header__nav-group-item header-menu__item header-list__item">
                    <a
                        class="header-menu__link header-list__link"
                        data-application="contact-sales-link"
                        [href]="secondaryNavigation.contactSales.url"
                        [innerHTML]="secondaryNavigation.contactSales.title"
                        websiteSpeculationRules
                        eagerness="moderate"
                    ></a>
                </div>
            }
            <div class="header__nav-group-item header-menu">
                @if (isKlaxoon) {
                    <website-language-selector-button
                        [locale]="headerService.klaxoonNextLocale"
                        [isDropdown]="false"
                        (languageSelectorClick)="headerService.changeKlaxoonLocale()"
                    ></website-language-selector-button>
                } @else {
                    <website-language-selector-button
                        [locale]="currentLocale"
                        [isOpen]="openedNavigationItem() === 'language-selector'"
                        [isDropdown]="true"
                        (languageSelectorClick)="onClickSubmenu('language-selector')"
                    ></website-language-selector-button>
                    <div class="header-menu__nav header-menu__nav--{{ theme }}">
                        <div class="nav-item" [ngClass]="{ 'nav-item--open': openedNavigationItem() }">
                            <div
                                [attr.id]="SUBMENU_CONTENT_BASE_ID + LANGUAGE_SELECTOR_LABEL"
                                [attr.aria-labelledby]="SUBMENU_TRIGGER_BASE_ID + LANGUAGE_SELECTOR_LABEL"
                            >
                                @if (separatedLanguages$ | async; as separatedLanguages) {
                                    <website-language-selector-section
                                        [languages]="separatedLanguages"
                                        [theme]="theme"
                                        [isAnyNavItemOpen]="isAnyNavItemOpen()"
                                        [isCurrentNavItemOpened]="openedNavigationItem() === 'language-selector'"
                                    ></website-language-selector-section>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div class="header__nav-group-item header-menu__item header-list__item">
                <a
                    class="header-menu__link header-list__link header-menu__link"
                    data-application="login-button"
                    [href]="secondaryNavigation.login.url"
                    [innerHTML]="secondaryNavigation.login.title"
                ></a>
            </div>

            @if (secondaryNavigation.bookDemo) {
                <div class="header__nav-group-item header-menu__item header-list__item">
                    <a
                        website-button-v3
                        link-target-detector
                        class="header__book-demo-link"
                        data-application="book-demo-link"
                        [buttonStyleProperties]="buttonStyleProperties"
                        [href]="secondaryNavigation.bookDemo.url"
                    >
                        {{ secondaryNavigation.bookDemo.title }}
                    </a>
                </div>
            }
            @if (secondaryNavigation.trialForm) {
                <div class="header__nav-group-item">
                    <button
                        website-button-v3
                        class="header__trial-form-button"
                        type="button"
                        [buttonStyleProperties]="buttonStyleProperties"
                        [id]="TRIAL_FORM_TRIGGER_ID"
                        [hasText]="true"
                        (click)="handleTrialButtonClick()"
                    >
                        {{ secondaryNavigation.trialForm.buttonSendText }}
                    </button>
                </div>
            }
        </div>
    }
    @if (
        !headerViewService.hideRightSide &&
        secondaryNavigation.trialForm &&
        !secondaryNavigation.trialForm.hasGoogleAuth
    ) {
        <div class="header__nav-group header__nav-group--trial-form">
            <div class="header__nav-group-item">
                <website-trial-form-v2
                    #trialForm
                    [size]="'small'"
                    [formType]="'inline'"
                    [colorScheme]="bottomCtaColorScheme"
                    [isErrorInTooltip]="true"
                    [isInputBordered]="true"
                    [inputLabelText]="secondaryNavigation.trialForm.inputLabelText"
                    [inputPlaceholderText]="secondaryNavigation.trialForm.inputPlaceholderText"
                    [buttonSendText]="secondaryNavigation.trialForm.buttonSendText"
                    [trialFormSendingData]="secondaryNavigation.trialForm.trialFormSendingData"
                    [environment]="secondaryNavigation.trialForm.environment"
                    [errorList]="secondaryNavigation.trialForm.errorList"
                    [loginRedirectUrl]="secondaryNavigation.trialForm.loginRedirectUrl"
                    [hasGoogleAuth]="false"
                    [emailValidation]="secondaryNavigation.trialForm.emailValidation"
                ></website-trial-form-v2>
            </div>
        </div>
    }
</div>
